import { Component, Input, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { UnitSizes } from "../../models/unitSizes";
import { DataTable } from "primeng/primeng";
import { isNullOrUndefined } from 'util';
declare const swal: any;

@Component({
  selector: 'scs-new-size-guide-sizes',
  templateUrl: './new-size-guide-sizes.component.html',
  styleUrls: ['./new-size-guide-sizes.component.css']
})
export class NewSizeGuideSizesComponent implements OnInit {
  @Input() pageSettings;
  @Input() clientData;

  unitSize: UnitSizes;
  selectedUnitSize: UnitSizes;
  displayUnitSizeDialog: boolean;
  newUnitSize: boolean;

  get sizesBroken() {
    return this.pageSettings.sizeGuide.sizes[-1];
  }

  constructor(public afService: FirebaseService) { }

  ngOnInit() {
    if (isNullOrUndefined(this.pageSettings.sizeGuide.sizes)) {
      this.pageSettings.sizeGuide.sizes = [];
    }
    else if (this.sizesBroken) {
      this.fixSizes();
    }
  }

  showUnitSizeDialogToAdd() {
    this.newUnitSize = true;
    this.unitSize = new UnitSizes();
    this.displayUnitSizeDialog = true;
  }

  onUnitSizeRowSelect(event) {
    this.newUnitSize = false;
    this.unitSize = event.data;
    this.displayUnitSizeDialog = true;
  }

  delete(unitSize) {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    })
      .then((willDelete) => {
        if (willDelete) {
          this.selectedUnitSize = unitSize;
          this.deleteUnitSize();
        } else {

        }
      })
  }

  saveUnitSize(e = null) {
    if (this.newUnitSize == true) {
      this.pageSettings.sizeGuide.sizes.push(this.unitSize);
    }
    else {
      this.unitSize = e.data;
      // this.unitSize.index = this.unitSize.shortName.replace(/\s/g, "");;
      this.pageSettings.sizeGuide.sizes[this.findIndex()] = this.unitSize;
    }

    this.unitSize = null;

    this.displayUnitSizeDialog = false;
    this.savePageSettings();
  }

  async savePageSettings(message = 'Page Settings Updated Successfully') {
    for (let tmp of this.pageSettings.sizeGuide.sizes) {
      delete tmp._$visited;
    }
    await this.afService.savePageSettings(this.clientData, this.pageSettings).then(() => {
      this.afService.openSnackBar(message);
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  async deleteUnitSize() {
    let index = this.findIndex();
    this.pageSettings.sizeGuide.sizes.splice(index, 1);
    this.selectedUnitSize = null;
    this.displayUnitSizeDialog = false;
    await this.savePageSettings();
    if (this.sizesBroken) {
      this.fixSizes();
    }
  }

  findIndex(): number {
    return this.pageSettings.sizeGuide.sizes.indexOf(this.selectedUnitSize);
  }

  fixSizes() {
    let tmp = [];
    for (let key in this.pageSettings.sizeGuide.sizes) {
      tmp.push(this.pageSettings.sizeGuide.sizes[key]);
    }
    this.pageSettings.sizeGuide.sizes = tmp;
    this.savePageSettings('Fixed the size guide!');
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/new-size-guide-sizes/new-size-guide-sizes.component.ts